import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popup-content-head" }
const _hoisted_2 = { class: "popup-content-body" }

import { ref, watch, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaPopup',
  props: {
    isOpen: { type: Boolean },
    targetRef: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const position = ref({ top: 0, left: 0 });

const updatePosition = () => {
  if (props.isOpen && props.targetRef) {
    const rect = props.targetRef.getBoundingClientRect();
    const popupWidth = 322; // ширина окна
    const screenWidth = window.innerWidth;

    let left = rect.left + window.scrollX;
    // не выходим ли за правый край экрана
    if (left + popupWidth > screenWidth) {
      left = screenWidth - popupWidth - 17; // отступаем на 17px от края
    }

    position.value = {
      top: rect.top,
      left: left,
    };
  }
}

const closePopup = () => emit('close')

// Обновляем позицию при открытии и добавляем обработчики событий
watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      updatePosition();
      window.addEventListener('resize', closePopup);
    } else {
      window.removeEventListener('resize', closePopup);
    }
  }
);

onUnmounted(() => {
  window.removeEventListener('resize', closePopup);
});

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (__props.isOpen)
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "popup-content",
        style: _normalizeStyle({ top: `${position.value.top}px`, left: `${position.value.left}px` })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "close-button",
            onClick: closePopup,
            "data-qa": "popup-button-close"
          }, [
            _createVNode(_component_vita_icon, { name: "cross-dark" })
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 4)), [
        [_directive_click_outside, () => closePopup()]
      ])
    : _createCommentVNode("", true)
}
}

})